import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AccountAlreadyVerified from "../components/MessageTemplates/accountAlreadyVerified";
import AccountAlreadyVerifiedPractitioner from "../components/MessageTemplates/Practitioner/accountAlreadyVerified";
import AccountAlreadyVerifiedPatient from "../components/MessageTemplates/Patient/accountAlreadyVerified";
import AccountAlreadyVerifiedStudent from "../components/MessageTemplates/Student/accountAlreadyVerified";
import EmailChangeSuccess from "../components/MessageTemplates/emailChangeSuccess";
import VerificationFailed from "../components/MessageTemplates/verificationFailed";
import VerificationSuccessful from "../components/MessageTemplates/verificationSuccessful";
import VerificationSuccessfulStudent from "../components/MessageTemplates/Student/verificationSuccessful";
import VerificationFailedStudent from "../components/MessageTemplates/Student/verificationFailed";
import VerificationSuccessfulPatient from "../components/MessageTemplates/Patient/verificationSuccessful";
import VerificationFailedPatient from "../components/MessageTemplates/Patient/verificationFailed";
import VerificationSuccessfulPractitioner from "../components/MessageTemplates/Practitioner/verificationSuccessful";
import VerificationFailedPractitioner from "../components/MessageTemplates/Practitioner/verificationFailed";
import PrivateLayout from "../layout/PrivateLayout";
import ForgotLogin from "../pages/ForgotLogin";
import Login from "../pages/Login";
import Register from "../pages/Register";
import VerifyPassword from "../pages/VerifyPassword";
import PublicRoute from "./PublicRoute";
import Contact from "../pages/Contact";
import LoginTwoFAPage from "../pages/LoginTwoFAPage";
import TwoFAsetup from "../pages/TwoFAsetup";
import PractitionerPromo from "../pages/PractitionerPromo";
import Ramtin from "../pages/Ramtin";
import Kim from "../pages/Kim";
import AppointmentScheduler from "../pages/Appointment";
import Report from "../pages/Report";
const AppRoutes = ({ history }) => {
  const publicRoutes = [
    { path: "/login", restricted: true, component: Login, exact: true },
    { path: "/forget", restricted: false, component: ForgotLogin, exact: true },
    { path: "/register", restricted: false, component: Register, exact: false },
    { path: "/contact", restricted: false, component: Contact, exact: true },
    {
      path: "/practitioners",
      restricted: false,
      component: PractitionerPromo,
      exact: true,
    },
    {
      path: "/appointment",
      restricted: false,
      component: AppointmentScheduler,
      exact: true,
    },
    {
      path: "/ramtin",
      restricted: false,
      component: Ramtin,
      exact: true,
    },
    {
      path: "/kim",
      restricted: false,
      component: Kim,
      exact: true,
    },
    { path: "/2fa", restricted: false, component: LoginTwoFAPage, exact: true },
    {
      path: "/2fa-setup",
      restricted: false,
      component: TwoFAsetup,
      exact: true,
    },
    {
      path: "/email-change-success",
      restricted: false,
      component: EmailChangeSuccess,
      exact: true,
    },
    {
      path: "/account-already-verified",
      restricted: false,
      component: AccountAlreadyVerified,
      exact: true,
    },
    {
      path: "/account-already-verified-patient",
      restricted: false,
      component: AccountAlreadyVerifiedPatient,
      exact: true,
    },
    {
      path: "/account-already-verified-student",
      restricted: false,
      component: AccountAlreadyVerifiedStudent,
      exact: true,
    },
    {
      path: "/account-already-verified-practitioner",
      restricted: false,
      component: AccountAlreadyVerifiedPractitioner,
      exact: true,
    },
    {
      path: "/verification-failed",
      restricted: false,
      component: VerificationFailed,
      exact: true,
    },
    {
      path: "/verification-successful",
      restricted: false,
      component: VerificationSuccessful,
      exact: true,
    },
    {
      path: "/verification-failed-practitioner",
      restricted: false,
      component: VerificationFailedPractitioner,
      exact: true,
    },

    {
      path: "/verification-successful-practitioner",
      restricted: false,
      component: VerificationSuccessfulPractitioner,
      exact: true,
    },
    {
      path: "/verification-successful-patient",
      restricted: false,
      component: VerificationSuccessfulPatient,
      exact: true,
    },

    {
      path: "/verification-failed-patient",
      restricted: false,
      component: VerificationFailedPatient,
      exact: true,
    },
    {
      path: "/verification-successful-student",
      restricted: false,
      component: VerificationSuccessfulStudent,
      exact: true,
    },
    {
      path: "/verification-failed-student",
      restricted: false,
      component: VerificationFailedStudent,
      exact: true,
    },
    {
      path: "/login/verifypasswordrequest/:userName/:token",
      restricted: false,
      component: VerifyPassword,
      exact: true,
    },
  ];

  return (
    <>
      <Switch history={history}>
        <Route exact={false} path="/app" component={PrivateLayout} />
        {publicRoutes.map((each) => (
          <PublicRoute
            key={each.path}
            exact={each.exact}
            path={each.path}
            restricted={each.restricted}
            component={each.component}
          />
        ))}
        <Redirect from="/" to="/app" />
      </Switch>
    </>
  );
};

export default AppRoutes;
